import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  background-color: transparent !important;
  & > a {
    color: #40a9ff;
  }
`;

const FooterContent = () => {
  return (
    <FooterContainer>
      {/* 2022 ©
      <Link
        to={'/'}
        style={{
          color: 'rgba(255, 255, 255, 0.4)',
        }}
      >
      BugRap&nbsp;
      </Link>{' '}
       All rights reserved */}

       ALL RIGHTS RESERVED © 2023 BUGRAP
    </FooterContainer>
  );
};

export default FooterContent;
